import { combineReducers } from 'redux';
import { createReducer } from '@reduxjs/toolkit';

import { ADJUST_APP_LINK } from '@travel/traveler-core/constants/common';

import { setShortUrl, updateRanData, updateShortUrl } from './actions';
import type { RanData, ShortUrl } from './types';

export const ranData = createReducer({} as RanData, (builder) => {
  builder.addCase(updateRanData, (_state, action) => action.payload);
});

export const defaultShortState = { hasShort: false, url: ADJUST_APP_LINK };

export const shortUrl = createReducer(
  {
    iOS: defaultShortState,
    android: defaultShortState,
  } as ShortUrl,
  (builder) => {
    builder
      .addCase(setShortUrl, (_state, action) => action.payload)
      .addCase(updateShortUrl, (state, action) => ({
        ...state,
        ...action.payload,
      }));
  },
);

const ranStoreReducer = combineReducers({
  ranData,
  shortUrl,
});

export default ranStoreReducer;
export type ProviderListState = ReturnType<typeof ranStoreReducer>;
